import { useSelector } from 'react-redux'
import * as Styled from './styled'
import RefillButton from 'components/RefillButton'
import { REF_LINKS } from 'consts/refLinks'
import { userSelectors } from 'store/features/user/selectors'
import { BUSINESS_PLAN_ID } from 'consts/user'
import GetUnlimitedBanner from 'components/GetUnlimitedBanner'

const VideoGenerationCredits = () => {
  const isFreeUser = useSelector(userSelectors.isFreeUser)
  const userCurrentPlanId = useSelector(userSelectors.userCurrentPlanId)

  const isBusinessUser = userCurrentPlanId === BUSINESS_PLAN_ID
  const showCredits = isFreeUser || isBusinessUser

  if (!showCredits) {
    return <GetUnlimitedBanner />
  }

  return (
    <Styled.VideoGenerationCreditsWrapper>
      <RefillButton referer={REF_LINKS.V_EDITOR_AI_VIDEO_REFILL} />
    </Styled.VideoGenerationCreditsWrapper>
  )
}

export default VideoGenerationCredits
